import useSWR from "swr";
import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";
import { authMiddleware } from "../http/middleware";

const useProfilePicture = () => {
  const w = wretch()
    .addon(QueryStringAddon)
    .middlewares([
      authMiddleware({
        scopes: ["https://graph.microsoft.com/User.Read"],
      }),
    ]);

  const fetcher = async (): Promise<string | null> => {
    try {
      const res = await w.url("https://graph.microsoft.com/v1.0/me/photo/$value").get().blob();

      return await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(res);
      });
    } catch (err: any) {
      // If user has no profile picture, Graph returns 404
      if (err.status === 404) return null;
      throw err;
    }
  };

  const { data } = useSWR("graph/profile-picture", fetcher, {
    revalidateOnFocus: false,
  });

  return {
    picture: data,
  };
};

export default useProfilePicture;
